import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import { ZakelijkProduct } from "shared/api/middleware-api-client";

export const getProductTotal = (product: ZakelijkProduct) => {
  // Discounted door price
  let total = product.doorType.price ?? 0;

  if (
    zakelijkProfielCodes.includes(product.doorType.code) &&
    product.doorLayout
  ) {
    total += product.doorLayout.price ?? 0;
  }
  // Add configured elements
  total +=
    (product.doorColor.price ?? 0) +
    (product.glassType.price ?? 0) +
    (product.doorHandle.price ?? 0);

  // Add extra options prices
  if (Array.isArray(product.extraOptionsPrices)) {
    total += product.extraOptionsPrices.reduce(
      (sum, price) => sum + (price ?? 0),
      0,
    );
  }

  return total;
};
